import { gql } from '@apollo/client';

export const GET_BROWSE_TOOLS_SAFE = gql`
  query BrowseToolsSafe($limit: Int, $offset: Int, $date: ISO8601Date!) {
    tools(limit: $limit, offset: $offset) {
      items {
        id
        name
        description
        disabled
        primaryImageUrl
        pricePerDayCents
        city
        postalCode
        nextAvailableDate(date: $date)
        locationArea(radiusM: 200) {
          latitude
          longitude
          radiusM
        }
        ratingAverage
        reviewCount
        categories {
          id
          name
          code
        }
      }
      totalCount
    }
  }
`;
